var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "title text-center my-4" }, [
    _vm._v("\n  " + _vm._s(_vm.$mpt(_vm.$t("message"))) + "\n"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }